/* eslint-disable react/jsx-key */
/* eslint-disable security/detect-object-injection */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { kRV_SubscribeNewsLetterAsync } from '../../actions/customProxy/NewsLetter/DataActionExtension.g';
import { IKrannichCNewletterFormViewProps } from './krannich-c-newletter-form';

export default (props: IKrannichCNewletterFormViewProps) => {
    const {
        context: {
            actionContext: {
                requestContext: { query }
            }
        },
        config: { heading, subHeading, termAndConditions },
        resources
    } = props;
    const Email = query?.Email;

    const [error, setError] = React.useState('');
    const [fieldError, setFieldError] = React.useState({});
    const [isDisable, setIsDisable] = React.useState(true);
    // const [respMessage, setRespMessage] = React.useState(false);
    const [respMessageValue, setRespMessageValue] = React.useState('');
    const [formVals, setformVals] = React.useState({
        companyName: '',
        fistName: '',
        lastName: '',
        zipCode: '',
        emailAddress: '',
        agree: false
    });
    const [validationCheck, setValidationCheck] = React.useState({});

    React.useEffect(() => {
        setformVals({
            companyName: '',
            fistName: '',
            lastName: '',
            zipCode: '',
            emailAddress: Email || '',
            agree: false
        });
    }, [query]);

    const termsAndConditionsLink = (
        <a
            title='Terms and Conditions'
            className='newsletter-checkbox-label'
            href={termAndConditions && termAndConditions?.linkUrl?.destinationUrl}
            target='_blank'
            rel='noreferrer'
        >
            {termAndConditions?.linkText}
        </a>
    );
    const usSiteFlag = props?.context?.actionContext?.requestContext?.apiSettings?.oun === props.context.app.config.ounNumberForUsSite;
    const formInputs = [
        {
            name: 'fistName',
            type: 'text',
            placeholder: resources.firstName,
            value: '',
            customType: 'text',
            label: `${resources.firstName}*`
        },
        {
            name: 'lastName',
            type: 'text',
            placeholder: resources.lastName,
            value: '',
            customType: 'text',
            label: `${resources.lastName}*`
        },
        {
            name: 'companyName',
            type: 'text',
            placeholder: resources.companyName,
            value: '',
            customType: 'textAll',
            label: `${resources.companyName} *`
        },
        {
            name: 'zipCode',
            customType: 'number',
            placeholder: usSiteFlag ? '00000' : '0000',
            value: '',
            type: 'text',
            label: usSiteFlag ? `${resources.zipCode} *` : `${resources.postCode} *`
        },
        {
            name: 'emailAddress',
            customType: 'email',
            placeholder: 'youremail@email.com',
            value: '',
            type: 'email',
            label: `${resources.emailAddress} *`
        },
        {
            type: 'checkbox',
            name: 'agree',
            value: false,
            customType: ''
        }
    ];

    React.useEffect(() => {
        void validateSubmitForm();
    }, [formVals]);

    const onChangeFormVal = async (customType: string, name: string, val: string | boolean, index: number) => {
        const res = await validateInputField(customType, val, index, name);
        if (res) {
            setformVals({ ...formVals, [name]: val });
        }
    };

    const validateEmail = (name: string, email: string, index: any) => {
        if (email === '') {
            setFieldError({ [index]: '' });
            setformVals({ ...formVals, [name]: email });
            setValidationCheck({ ...validationCheck, [index]: true });
            return true;
        } else if (
            String(email)
                .toLowerCase()
                .match(
                    // eslint-disable-next-line security/detect-unsafe-regex
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
        ) {
            setFieldError({ [index]: '' });
            setformVals({ ...formVals, [name]: email });
            setValidationCheck({ ...validationCheck, [index]: true });
            return true;
        } else {
            setFieldError({ [index]: resources.validEmailAddressMessage });
            setValidationCheck({ ...validationCheck, [index]: false });
            setIsDisable(true);
        }
        return;
    };

    const validateNumber = (number: string, index: any, name: string) => {
        const usSiteFlag = props?.context?.actionContext?.requestContext?.apiSettings?.oun === props.context.app.config.ounNumberForUsSite;
        const phoneReg = /^[0-9\s]*$/;
        if (number.length > 10 && name === 'zipCode') {
            setFieldError({ [index]: `${usSiteFlag ? resources.zipCode : resources.postCode} ${resources.canOnlyBeDigitseKey}` });
            return false;
        } else {
            if (number === '' || phoneReg.test(number)) {
                setFieldError({ [index]: '' });
                setValidationCheck({ ...validationCheck, [index]: true });
                return true;
            } else {
                setFieldError({ [index]: resources.enterNumbersOnlyMessage });
                setValidationCheck({ ...validationCheck, [index]: false });
                return false;
            }
        }
    };

    const validateText = (text: string, index: any) => {
        const textReg = /^[a-zA-Z]+$/;

        if (text === '' || textReg.test(text)) {
            setFieldError({ [index]: '' });
            setValidationCheck({ ...validationCheck, [index]: true });
            return true;
        } else {
            setFieldError({ [index]: resources.enterAlphabetsOnlyMessage });
            return false;
        }
    };

    async function validateInputField(customType: string, val: string | boolean, index: any, name: string) {
        if (typeof val === 'boolean') {
            return true;
        }
        if (customType === 'text') {
            return validateText(val, index);
        }
        if (customType === 'number') {
            return validateNumber(val, index, name);
        }
        return true;
    }

    const validateSubmitForm = async () => {
        if (
            formVals.companyName !== '' &&
            formVals.fistName !== '' &&
            formVals.lastName !== '' &&
            formVals.zipCode !== '' &&
            formVals.emailAddress !== ''
        ) {
            if (formVals.agree === true) {
                //VSI customization
                //if validation array contains any 'false' submit button will remain disabled unless all values are true and good to go
                const errors = Object.values(validationCheck);
                if (errors.includes(false)) {
                    return;
                } else {
                    setIsDisable(false);
                    setError('');
                }
            } else {
                setIsDisable(true);
                setError(resources.acceptTermsConditionsMessage);
            }
        } else {
            setIsDisable(true);
            setError(resources.allFieldsMandatoryMessage);
        }
    };

    const handlerOnSubmit = async () => {
        const subscribeNewsLetter = {
            Company: formVals.companyName,
            FirstName: formVals.fistName,
            LastName: formVals.lastName,
            ZipCode: formVals.zipCode,
            EmailAddress: formVals.emailAddress
        };

        const ctx = {
            callerContext: props.context.actionContext
        };

        await kRV_SubscribeNewsLetterAsync(ctx, subscribeNewsLetter).then(resp => {
            // setRespMessage(true);
            setRespMessageValue(resp?.Message!);
        });

        setformVals({
            companyName: '',
            fistName: '',
            lastName: '',
            zipCode: '',
            emailAddress: '',
            agree: false
        });
        setIsDisable(true);
        setError('');
        setFieldError('');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className='subs-form-container '>
            <div className='subs-title-container'>
                <h2 className='subs-heading'>{heading}</h2>
                <p className='subs-subheading'>
                    <span>{subHeading}</span> <span className='sub-form-error'>{error}</span>
                    <span className='subs-info-parah'></span>
                </p>
            </div>
            {respMessageValue === '' || respMessageValue === undefined ? null : respMessageValue === 'Email address already exist.' ? (
                <div className='news-letter-danger-message'>{'Email address already exists.'}</div>
            ) : (
                <div className='news-letter-success-message'>{respMessageValue}</div>
            )}
            <div className='subs-input-container'>
                {formInputs.map((input, index) => {
                    if (input.type !== 'info-text') {
                        return (
                            <div key={index} className={`${input.name}`}>
                                {input.type === 'checkbox' ? (
                                    <label htmlFor={`${input.name}`} className='sub-form-label'>
                                        <span>
                                            {resources.acceptTermsConditionsLinkMessageOne} {termsAndConditionsLink}{' '}
                                            {resources.acceptTermsConditionsLinkMessageTwo}
                                        </span>
                                    </label>
                                ) : (
                                    <label htmlFor={`${input.name}`} className='sub-form-label'>
                                        {input.label}
                                    </label>
                                )}
                                <input
                                    id={input.name}
                                    name={input.name}
                                    type={input.type}
                                    placeholder={input.placeholder}
                                    required
                                    value={formVals[input.name]}
                                    onChange={e => {
                                        if (input.type === 'checkbox') {
                                            const newValue = formVals[input.name];
                                            void onChangeFormVal(input.customType, input.name, !newValue, index);
                                        } else {
                                            void onChangeFormVal(input.customType, input.name, e.target.value, index);
                                        }
                                    }}
                                    onBlur={e => {
                                        if (input.type === 'email') {
                                            validateEmail(input.name, e.target.value, index);
                                        }
                                    }}
                                    checked={formVals[input.name]}
                                />
                                {<p>{fieldError[index]}</p>}
                            </div>
                        );
                    } else {
                        return <p>{input.label}</p>;
                    }
                })}
                <input
                    className='sub-form-btn'
                    aria-label='submit-button'
                    disabled={isDisable}
                    onClick={handlerOnSubmit}
                    value={resources.submitButton}
                />
            </div>
        </div>
    );
};
